import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Divider } from '../../divider/Divider.mjs';

const DatePickerDivider = (props) => /* @__PURE__ */ jsx(StyledDivider, { color: "black006", ...props });
const StyledDivider = styled(Divider, {
  my: 4
});

export { DatePickerDivider as default };
//# sourceMappingURL=Divider.mjs.map
